var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RelatedLetters',{attrs:{"letterInfo":_vm.letterInfo,"letters":_vm.letters,"relatedLetters":_vm.relatedLetters,"type":'internal',"isLoaded":_vm.isLoaded},on:{"getInfo":_vm.getInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }